import { If, asyncFlow, asyncPipe } from '@helo/utils'
import { tap } from '@helo/utils'

import { ConfigSlice } from '../config/configSlice'
import { AuthSlice, getPath } from './authSlice'
import { AuthSliceParts } from './authSlice.parts'

type AuthInitStore = AuthSlice & ConfigSlice

const initializeAuthFlow = () =>
  asyncFlow(
    asyncFlow.inputExtends<AuthSlice>(),
    AuthSliceParts.createAuth0Client(),
    If.then(AuthSliceParts.shouldSkipAuthSetup(), asyncFlow.return),
    AuthSliceParts.setInitializing(),
    AuthSliceParts.handleAuth0RedirectCallback(),
    AuthSliceParts.getAuth0Token(),
    AuthSliceParts.addTokenToHeaders(),
    AuthSliceParts.getAuth0User(),
    AuthSliceParts.setupUser(),
    AuthSliceParts.setupExpirations(),
    AuthSliceParts.setIsAuthenticated(),
    asyncFlow.catch(async (error, prev) => {
      const store = prev as AuthInitStore
      console.error('initializeAuth error', error)
      // TODO: set up application error handling that can pause setup waiting for redirect or handle showing messages.
      await AuthSliceParts.loginWithRedirect({
        returnTo: store.auth.redirectTo ?? getPath(),
      })(store)
      return prev as AuthSlice
    }),
  )

const initializeAuth = initializeAuthFlow

const logout =
  () =>
  async (state: AuthSlice): Promise<AuthSlice> =>
    asyncPipe(
      state,
      tap(() => {
        const client = state.auth.auth0Client
        if (client) {
          client.logout({
            logoutParams: { returnTo: window.location.origin },
          })
        }
      }),
    )

const fetchCurrentUser =
  () =>
  <T extends AuthSlice>(globalState: T) =>
    asyncPipe(globalState, AuthSliceParts.getCurrentUser()) as Promise<T>

export const AuthSliceActions = {
  initializeAuth,
  logout,
  fetchCurrentUser,
}
